import { COLORS } from '@btime/constants'
import React from 'react'

import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const StructureSection = () => (
  <View id="3">
    <Text bold size="small" id={'3'}>
      3. ESTRUTURA
    </Text>

    <br />

    <Text bold size="small" id={'3.1'}>
      3.1 ANTECIPAÇÃO (Análise Preliminar)
    </Text>

    <Text>
      Esta etapa envolve a análise de novos projetos, instalações, produtos, métodos ou processos de trabalho ou de
      modificação já existentes.
      <br />
      O objetivo é a identificação dos perigos e das avaliações dos riscos ocupacionais e a introdução das medidas de
      controle necessárias, antecipando-se a exposição aos riscos.
      <br />O responsável da empresa deverá assegurar que toda modificação e/ou novo projeto a ser implantado seja
      avaliado preliminarmente com relação a identificação de perigos e avaliação dos riscos potencialmente presentes.
    </Text>

    <Separator weight={4} />

    <Text bold size="small" id={'3.2'}>
      3.2 RECONHECIMENTO
    </Text>

    <br />

    <Text>
      Esta etapa envolve a identificação qualitativa e a explicitação, dos riscos existentes nos ambientes de trabalho.
      <br /> A determinação e localização das possíveis fontes geradoras, trajetórias e meios de propagação,
      caracterização das atividades e do tipo de exposição, identificação das funções e determinação do número de
      trabalhadores expostos ao risco. A obtenção de dados existentes na empresa, indicativos de possível
      comprometimento da saúde decorrentes do trabalho, possíveis danos à saúde relacionados aos riscos identificados
      disponíveis na literatura técnica.
      <br /> A descrição das medidas de controle já existentes na empresa e das possíveis alterações para aumentar a sua
      eficiência na redução ou eliminação dos riscos ambientais.
    </Text>

    <Separator weight={4} />

    <Text bold size="small" id={'3.3'}>
      3.3 AVALIAÇÃO DO RISCO
    </Text>

    <Text>
      Para efeito deste trabalho, adotamos as seguintes definições para a{' '}
      <b>
        <u>avaliação dos riscos</u>
      </b>
      , que podem ser classificados em quatro níveis de acordo com orientações da metodologia de (
      <i>American Industrial Hygiene Association</i>).
      <br /> Estimar e definir a categoria de cada risco, a partir da combinação dos valores atribuídos para{' '}
      <b>PROBABILIDADE</b> e <b>POTENCIAL DE DANO</b>, utilizando a matriz apresentada na Tabela{' '}
      <b>GRADUAÇÃO DE RISCO</b>, que define a O risco resultante dessa combinação.
    </Text>

    <br />

    <Text bold size="small" id={'3.3.1'}>
      3.3.1 PROBABILIDADE (P)
    </Text>

    <Text>
      A gradação da probabilidade da ocorrência do dano (efeito crítico) é feita atribuindo-se um índice de
      probabilidade (P) variando de 1 a 4, cujo significado está relacionado no quadro.
    </Text>

    <br />

    <Text bold size="small">
      EXPOSIÇÃO (Probabilidade) = TIPO DE EXPOSIÇÃO X CONCENTRAÇÃO / INTENSIDADE
    </Text>

    <Table width="100%" center>
      <TableRow>
        <TableHeadText colSpan={3}>CLASSIFICAÇÃO DO TIPO DE EXPOSIÇÃO</TableHeadText>
      </TableRow>
      <TableRow>
        <TableHeadText>INTENSIDADE</TableHeadText>
        <TableHeadText>TIPO DE EXPOSIÇÃO</TableHeadText>
        <TableHeadText>CONCEITO</TableHeadText>
      </TableRow>

      <TableRow>
        <TableColText>LEVE</TableColText>
        <TableColText>
          Exposição habitual ao agente, em intensidade inferior ao nível de ação ou insuficiente para oferecer risco à
          saúde.{' '}
        </TableColText>
        <TableColText>Remota possibilidade de ocorrência de danos à saúde.</TableColText>
      </TableRow>

      <TableRow>
        <TableColText>MODERADA</TableColText>
        <TableColText>
          Exposição ao agente entre o nível de ação e limite de tolerância, ou em condição de oferecer risco de dano de
          natureza leve à saúde.
        </TableColText>
        <TableColText>Poderá ocorrer danos à saúde a médio ou longo prazo.</TableColText>
      </TableRow>

      <TableRow>
        <TableColText>SEVERA</TableColText>
        <TableColText>
          Exposição ao agente em intensidade superior ao limite de tolerância, ou suficiente para causar dano
          significativo à saúde.
        </TableColText>
        <TableColText>Poderá ocorrer a médio ou longo prazo, danos à saúde.</TableColText>
      </TableRow>
    </Table>

    <br />

    <Table width="100%" center>
      <TableRow>
        <TableHeadText colSpan={3}>CONCENTRAÇÃO / INTENSIDADE</TableHeadText>
      </TableRow>
      <TableRow>
        <TableHeadText rowSpan={2}>QUANTIDADE INTENSIDADE</TableHeadText>
        <TableHeadText colSpan={2}>AVALIAÇÃO QUANTITATIVA</TableHeadText>
      </TableRow>
      <TableRow>
        <TableHeadText>SITUAÇÃO AVALIAÇÃO</TableHeadText>
        <TableHeadText>AVALIAÇÃO QUALITATIVA</TableHeadText>
      </TableRow>

      <TableRow>
        <TableColText>PEQUENA</TableColText>
        <TableColText>Exposição a quantidades ou intensidades muito pequenas</TableColText>
        <TableColText>
          <u>EXPOSIÇÃO MÉDIA ESTIMADA:</u> ABAIXO DE 10% DO LT
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText>MÉDIA</TableColText>
        <TableColText>
          Exposição a quantidades ou intensidades médias, e não podemos garantir que os meios de controle sobre as
          exposições são suficientes.
        </TableColText>
        <TableColText>
          <u>EXPOSIÇÃO MÉDIA ESTIMADA:</u> ABAIXO DE 50% DO LT
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText>GRANDE</TableColText>
        <TableColText>
          Exposição a quantidades ou intensidades significativas (possibilidade de se situarem entre o Nível de ação e o
          limite de tolerância) e não podemos garantir que os meios de controle sobreas exposições são suficientes.
        </TableColText>
        <TableColText>
          <u>EXPOSIÇÃO MÉDIA ESTIMADA:</u> ENTRE 50% DO LT E O LT
        </TableColText>
      </TableRow>
      <TableRow>
        <TableColText>MUITO GRANDE</TableColText>
        <TableColText>
          Exposição a grandes intensidades ou quantidades (possibilidade de se situarem acima do limite de tolerância) e
          não podemos garantir que os meios de controle sobre as exposições são suficientes.
        </TableColText>
        <TableColText>
          <u>EXPOSIÇÃO MÉDIA ESTIMADA:</u> ACIMA DO LTDOC BASE
        </TableColText>
      </TableRow>
    </Table>

    <Text>*LT – Limite de tolerância</Text>

    <Separator weight={4} />

    <Table width="100%" center>
      <TableRow>
        <TableHeadText colSpan={5}>PROBABILIDADE</TableHeadText>
      </TableRow>

      <TableRow>
        <TableHeadText>GRADUAÇÃO</TableHeadText>
        <TableHeadText>EVENTUAL</TableHeadText>
        <TableHeadText>HABITUAL</TableHeadText>
        <TableHeadText>INTERMITENTE</TableHeadText>
        <TableHeadText>PERMANENTE</TableHeadText>
      </TableRow>

      <TableRow>
        <TableHeadText>PEQUENA</TableHeadText>
        <TableColText>1-BAIXA</TableColText>
        <TableColText>1-BAIXA</TableColText>
        <TableColText>2-MÉDIA</TableColText>
        <TableColText>2-MÉDIA</TableColText>
      </TableRow>

      <TableRow>
        <TableHeadText>MÉDIA</TableHeadText>
        <TableColText>1-BAIXA</TableColText>
        <TableColText>2-MÉDIA</TableColText>
        <TableColText>3-ALTA</TableColText>
        <TableColText>3-ALTA</TableColText>
      </TableRow>

      <TableRow>
        <TableHeadText>GRANDE</TableHeadText>
        <TableColText>2-MÉDIA</TableColText>
        <TableColText>3-ALTA</TableColText>
        <TableColText>3-ALTA</TableColText>
        <TableColText>4-MUITO ALTA</TableColText>
      </TableRow>
      <TableRow>
        <TableHeadText>MUITO GRANDE</TableHeadText>
        <TableColText>2-MÉDIA</TableColText>
        <TableColText>3-ALTA</TableColText>
        <TableColText>4-MUITO ALTA</TableColText>
        <TableColText>4-MUITO ALTA</TableColText>
      </TableRow>
    </Table>

    <Separator weight={8} />

    <Text bold size="small" id={'3.3.2'}>
      3.3.2 POTENCIAL DE DANO (SEVERIDADE)
    </Text>

    <Text>
      A severidade dos riscos é caracterizada pelas consequências possíveis de uma situação de perigo à segurança
      operacional classificadas de 1 a 4, tomando como referência a pior condição previsível.
    </Text>

    <br />

    <Table width="100%" center>
      <TableRow>
        <TableHeadText>Grau de Severidade</TableHeadText>
        <TableHeadText>Conceito</TableHeadText>
        <TableHeadText>Ação</TableHeadText>
      </TableRow>

      <TableRow>
        <TableColText>1</TableColText>
        <TableColText>
          <b>Risco Inexistente/ baixo:</b> contato eventual a baixas concentrações e abaixo do nível de ação
        </TableColText>
        <TableColText>Nenhuma ação ou educação dos colaboradores através de informativos e treinamentos</TableColText>
      </TableRow>

      <TableRow>
        <TableColText>2</TableColText>
        <TableColText>
          <b>Risco Moderado:</b> contato frequente com concentrações acima do nível ação, mas abaixo do limite de
          tolerância
        </TableColText>
        <TableColText>Avaliação quantitativa e ações de controle periódicas</TableColText>
      </TableRow>
      <TableRow>
        <TableColText>3</TableColText>
        <TableColText>
          <b>Risco Elevado:</b> contato habitual e permanente com concentrações/intensidades acima do limite de
          tolerância
        </TableColText>
        <TableColText>Ação de controle sistemático e acompanhamento periódico</TableColText>
      </TableRow>
      <TableRow>
        <TableColText>4</TableColText>
        <TableColText>
          <b>Risco Alto:</b> contato com concentrações que colocam em risco a vida do colaborador
        </TableColText>
        <TableColText>Ação imediata para redução da exposição</TableColText>
      </TableRow>
    </Table>

    <Separator weight={8} />

    <Text bold size="small" id={'3.3.3'}>
      3.3.3 GRADUAÇÃO DO RISCO
    </Text>

    <Text>
      A combinação da severidade com a probabilidade do efeito potencial de um perigo ocorrer, no pior cenário
      verossímil possível.
    </Text>

    <Separator weight={8} />

    <Table width="100%">
      <TableRow>
        <TableColText colSpan={6} bold align="center" size="small">
          RISCO = EXPOSIÇÃO (Probabilidade) X POTENCIAL (Severidade)
        </TableColText>
      </TableRow>

      <TableRow>
        <TableHeadText colSpan={6} align="center">
          NÍVEL DE RISCO
        </TableHeadText>
      </TableRow>

      <TableRow>
        <TableColText rowSpan={4} bold align="center" width="120px" size="small">
          POTENCIAL DE DANOS / Severidade
        </TableColText>

        <TableColText align="center" height="80px">
          4
        </TableColText>

        <TableColText align="center" bgColor={COLORS.yellow}>
          MODERADO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightBlue}>
          ALTO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightRed}>
          CRITICO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightRed}>
          CRITICO
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText align="center" height="80px">
          3
        </TableColText>

        <TableColText align="center" bgColor={COLORS.yellow}>
          MODERADO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightBlue}>
          ALTO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightBlue}>
          ALTO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightRed}>
          CRITICO
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText align="center" height="80px">
          2
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightGreen}>
          BAIXO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.yellow}>
          MODERADO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightBlue}>
          ALTO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightBlue}>
          ALTO
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText align="center" height="80px">
          1
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightGreen}>
          BAIXO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.lightGreen}>
          BAIXO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.yellow}>
          MODERADO
        </TableColText>

        <TableColText align="center" bgColor={COLORS.yellow}>
          MODERADO
        </TableColText>
      </TableRow>

      <TableRow>
        <TableCol height="90px" rowSpan={2} colSpan={2} />

        <TableColText align="center" height="30px" bold size="small">
          1-BAIXA
        </TableColText>

        <TableColText align="center" bold size="small">
          2-MÉDIA
        </TableColText>

        <TableColText align="center" bold size="small">
          3-ALTA
        </TableColText>

        <TableColText align="center" bold size="small">
          3-MUITO ALTA
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText align="center" colSpan={4} bold size="small">
          EXPOSIÇÃO / Probabilidade
        </TableColText>
      </TableRow>
    </Table>

    <Separator weight={8} />

    <Text bold size="small" id={'3.4'}>
      3.4 ESTABELECIMENTO DE PRIORIDADES E METAS DE AVALIAÇÃO E CONTROLE
    </Text>

    <Separator weight={4} />

    <Text>
      Neste PGR a priorização das medidas de controle, caso sugeridas, é adotada conforme a categorização de risco
      definida segundo metodologia de graduação de riscos (MULHAUSEN & DAMIANO) e AIHA (American Industrial Hygiene
      Association).
    </Text>

    <Separator weight={8} />

    <Table width="100%" center>
      <TableRow>
        <TableHeadText align="center">RISCO (exposição resultante)</TableHeadText>
        <TableHeadText align="center">APRECIAÇÃO</TableHeadText>
        <TableHeadText align="center">AÇÕES</TableHeadText>
      </TableRow>

      <TableRow>
        <TableColText align="center" bgColor={COLORS.lightGreen}>
          BAIXO
          <br />
          (1 a 2)
        </TableColText>
        <TableColText align="center">
          <b>ACEITÁVEL</b>
          <br />
          (o risco deve ser monitorado)
        </TableColText>
        <TableColText>
          <ul>
            <li>Nenhuma ação adicional é necessária;</li>
            <li>
              Considerações podem ser feitas para avaliar soluções mais efetivas e de menor custo ou ainda melhorias que
              não envolvem custo;
            </li>
            <li>Procedimentos e/ou objetivos e metas são opcionais;</li>
            <li>Registrar e informar aos trabalhadores.</li>
          </ul>
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText align="center" bgColor={COLORS.yellow}>
          MODERADO
          <br />
          (3 a 4)
        </TableColText>
        <TableColText rowSpan={2} align="center">
          <b>TOLERÁVEL</b>
          <br />
          (estudar medidas para redução do risco){' '}
        </TableColText>
        <TableColText rowSpan={2}>
          <ul>
            <li>
              Esforços devem ser feitos para reduzir o risco, porém os custos de prevenção devem ser cuidadosamente
              estimados e definidos;
            </li>
            <li>
              Quando avaliadas e definidas como aplicáveis, as medidas a implementar devem ter definidos seus
              responsáveis e prazos de conclusão;
            </li>
            <li>
              Avaliações adicionais devem ser definidas, para estabelecer mais precisamente as medidas de controle a
              serem melhoradas;
            </li>
            <li>Procedimentos de controle operacional e/ou planos de emergência são necessários;</li>
          </ul>
          <b>NOTA:</b> É permitida a existência de risco TOLERÁVEL, mesmo depois de implementados os novos controles,
          desde que seja evidenciada sua tratativa e a inexistência de tecnologia e/ou inviabilidade
          técnica/administrativa, para a redução do risco.
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText align="center" bgColor={COLORS.lightBlue}>
          ALTO
          <br />
          (6 a 9)
        </TableColText>
      </TableRow>

      <TableRow>
        <TableColText align="center" bgColor={COLORS.lightRed}>
          CRÍTICO
          <br />
          (12 a 16)
        </TableColText>
        <TableColText align="center">
          <b>INACEITÁVEL</b>
          <br />
          (paralisação da atividade e definição de ações corretivas para reduzir o risco)
        </TableColText>
        <TableColText>
          <ul>
            <li>O trabalho não deve ser iniciado até que o risco tenha sido reduzido para o nível TOLERÁVEL;</li>
            <li>
              Provavelmente recursos consideráveis deverão ser alocados para reduzir o risco, o que implica em escalar o
              plano de ações a níveis mais elevados de responsabilidade;
            </li>
            <li>Quando o trabalho se encontrar em progresso, ação urgente deve ser adotada;</li>
            <li>Procedimentos de controle operacional, planos de emergência e objetivos e metas são mandatários.</li>
          </ul>
        </TableColText>
      </TableRow>
    </Table>
    <br />
    <Text>
      De acordo com o levantamento dos dados para execução do PGR, será elaborado um <b>Plano de ação</b> contemplando
      atividades, metas e prioridades a serem implementadas de forma a eliminar, minimizar ou controlar os riscos
      ocupacionais.
    </Text>
    <Text>
      Caso a tabela indique que para determinado risco não é necessário realizar uma ação específica, mas a empresa
      venha a receber uma autuação de organismo fiscalizador, ou venha acontecer algum acidente em decorrência do perigo
      relacionado ao risco, deve-se realizar alguma ação para minimizar esse risco, independente do resultado obtido na
      tabela.
    </Text>
    <Text>
      O plano de ação deve ser amplo e deve atender as reais necessidades de melhoria da empresa, não se prendendo
      somente as exigências da NR 1.
    </Text>
    <Separator weight={4} />
    <Text bold size="small">
      Avaliação dos Riscos Ocupacionais e da exposição
    </Text>
    <Text>
      Envolve o monitoramento dos riscos ocupacionais para a determinação da intensidade dos agentes físicos e a
      concentração dos agentes químicos, visando o dimensionamento da exposição dos trabalhadores.
    </Text>
    <Text>
      A avaliação quantitativa deverá ser realizada sempre que necessária para comprovar o controle da exposição aos
      agentes identificados no reconhecimento, dimensionar a exposição ocupacional dos grupos de trabalhadores e
      subsidiar o equacionamento das medidas de prevenção.
    </Text>
    <Separator weight={8} />
    <Text bold size="small" id={'3.5'}>
      3.5 IMPLANTAÇÃO DE MEDIDAS DE CONTROLE E AVALIAÇÃO DA EFICÁCIA
    </Text>
    <Text>
      Envolve a adoção de medidas necessárias e suficientes para a eliminação ou redução dos riscos ambientais. As
      medidas preventivas serão obrigatórias sempre que for atingido o nível de ação para os agentes físicos e químicos,
      definido no próximo item, incluindo o monitoramento periódico, informação aos trabalhadores e o controle médico.
    </Text>
    <Text>
      O PGR será de abrangência e profundidade gradual às características dos riscos e das necessidades de controle.
    </Text>
    <Text>
      Deverão ainda ser propostas medidas necessárias e suficientes para a eliminação, minimização ou controle dos
      riscos ocupacionais, sempre que for verificada uma ou mais das seguintes situações:
    </Text>
    <Text>
      <li>Riscos potenciais na fase de antecipação;</li>
      <li>Quando forem constatados riscos evidentes a saúde na fase de reconhecimento;</li>
      <li>
        Quando os resultados das avaliações quantitativas forem superiores aos valores limites previstos na NR-15 ou na{' '}
        <i>American Conference of Governmental Industrial Hygienists</i> - ACGIH;
      </li>
      <li>
        Quando, após a avaliação quantitativa dos agentes, for constatada exposição acima dos Níveis de ação, quais
        sejam: para agentes químicos, metade dos Limites de Tolerância; para ruído, a dose de 0,5;
      </li>
      <li>
        Houver evidências de associação, por meio do controle médico da saúde, entre as lesões e os agravos à saúde dos
        trabalhadores com os riscos e as situações de trabalhos identificados;
      </li>
      <li>Na ocorrência de acidentes ou doenças relacionadas ao trabalho;</li>
      <li>Exigências previstas em Normas Regulamentadoras e nos dispositivos legais determinarem; </li>
      <li>A classificação dos riscos ocupacionais assim determinar.</li>
    </Text>
    <Text>As medidas de controle a serem implantadas obedecerão a ordem de prioridade:</Text>
    <Text>
      <li>Eliminação dos fatores de risco;</li>
      <li>Minimização e controle dos fatores de riscos, com a adoção de medidas de proteção coletiva;</li>
      <li>
        Minimização e controle dos fatores de riscos, com adoção de medidas administrativas ou de organização do
        trabalho; e
      </li>
      <li>Adoção de medidas de proteção individual.</li>
    </Text>
    <Text>
      Quando comprovada pela organização a inviabilidade técnica da adoção de medidas de proteção coletiva, ou quando
      estas não forem suficientes ou encontrarem-se em fase de estudo, planejamento ou implantação ou, ainda, em caráter
      complementar ou emergencial, deverão ser adotadas outras medidas, obedecendo-se a seguinte hierarquia:
    </Text>
    <Text>
      <ul>
        <li>Medidas de caráter administrativo ou de organização do trabalho;</li>
        <li>Utilização de Equipamento de Proteção Individual – EPI.</li>
      </ul>
    </Text>
    <Text>
      O emprego do EPI deverá ser adotado de acordo com as determinações da NR-6 – Equipamentos de Proteção Individual.
      Vale ressaltar que os EPI que porventura sejam utilizados pelos trabalhadores durante o desenvolvimento das
      atividades serão mencionados no Anexo 1 – Reconhecimento dos Riscos. As medidas de controle deverão ser previstas
      no Plano de Ação, constante do PGR, após consenso com o responsável pela implementação deste programa.
    </Text>
    <Text>Seguem alguns exemplos de medidas de controle a serem consideradas:</Text>
    <Text>
      <ul>
        <li>Substituição do agente agressivo;</li>
        <li>Mudança ou alteração do processo ou operação</li>
        <li>Enclausuramento da fonte;</li>
        <li>Segregação do processo ou operação;</li>
        <li>Modificação de projetos;</li>
        <li>Limitação do tempo de exposição;</li>
        <li>Utilização de equipamento de proteção individual – EPI;</li>
        <li>Outras.</li>
      </ul>
    </Text>
    <Text>
      O <b>CONTROLE</b> existente e ou sugerida será apresentado no quadro da avaliação de cada GHE, onde também será
      mencionada a sua eficácia e o grau de prioridade para ação sugerida.
    </Text>
    <Separator weight={8} />
    <Text bold size="small" id={'3.6'}>
      3.6 MONITORAMENTO DA EXPOSIÇÃO DO RISCO
    </Text>
    <Separator weight={8} />
    <Text>
      Quando detectada alguma exposição à saúde dos empregados, será comunicado ao Médico do Trabalho coordenador do
      PCMSO, para as devidas providências. Da mesma forma, toda vez que houver suspeita médica com relação à exposição
      ambiental, o Médico do Trabalho responsável pelo PCMSO deverá acionar o técnico responsável pelo PGR, para as
      avaliações e sugestões de controles necessários à eliminação, redução a níveis toleráveis de exposição e/ou
      aplicação de medidas de proteção aos empregados.
    </Text>
    <Separator weight={8} />
    <Text bold size="small" id={'3.7'}>
      3.7 REGISTRO, MANUTENÇÃO E DIVULGAÇÃO DOS DADOS
    </Text>
    <Text>
      Quando detectada alguma exposição à saúde dos empregados, será comunicado ao Médico do Trabalho coordenador do
      PCMSO, para as devidas providências. Da mesma forma, toda vez que houver suspeita médica com relação à exposição
      ambiental, o Médico do Trabalho responsável pelo PCMSO deverá acionar o técnico responsável pelo PGR, para as
      avaliações e sugestões de controles necessários à eliminação, redução a níveis toleráveis de exposição e/ou
      aplicação de medidas de proteção aos empregados.
    </Text>
    <Separator weight={4} />
    <Text>
      <b>Registro:</b> Os registros dos dados serão feitos através de avaliações, levantamentos e monitoramento dos
      riscos que foram levantados na antecipação das atividades do que os colaboradores possam estar expostos e
      registrados neste programa; O registro de dados deverá estar sempre disponível aos trabalhadores interessados ou
      seus representantes e permitir o imediato acesso para as autoridades competentes.
    </Text>
    <Text>
      <b>Manutenção:</b> O inventário de riscos ocupacionais deve ser mantido atualizado, o histórico de atualizações do
      Programa de Gerenciamento de Risco – PGR e os documentos que o compõem, devem ser mantidos por um período mínimo
      de 20 anos ou pelo período estabelecido em normatização específica, os documentais com histórico de revisões devem
      ser devidamente assinados e datados.
    </Text>
    <Text>
      <b>Divulgação:</b> Os empregadores divulgarão aos trabalhadores de maneira apropriada através de meios eletrônicos
      ou informativo sobre os riscos ocupacionais que possam originar-se nos locais de trabalho e sobre os meios
      disponíveis para prevenir ou limitar tais riscos e para proteger-se dos mesmos.
    </Text>
    <Separator weight={4} />
    <Text bold size="small" id={'3.8'}>
      3.8 PERIODICIDADE E FORMA DE AVALIAÇÃO DO PGR
    </Text>
    <Text>
      A avaliação de riscos deve constituir um processo contínuo, o PGR será revisto a cada dois anos ou sempre que
      necessário quando da ocorrência das seguintes situações:
      <ul>
        <li>Após implementação das medidas de prevenção, para avaliação de riscos residuais;</li>
        <li>
          Após inovações e modificações nas tecnologias, ambientes, processos, condições, procedimentos e organização do
          trabalho que impliquem em novos riscos ou modifiquem os riscos existentes;
        </li>
        <li>Quando identificadas inadequações, insuficiências ou ineficácias das medidas de prevenção;</li>
        <li>Na ocorrência de acidentes ou doenças relacionadas ao trabalho;</li>
        <li>Quando houver mudança nos requisitos legais aplicáveis.</li>
      </ul>
      Observação.: No caso de organizações que possuírem certificações em sistema de gestão de SST, o prazo poderá ser
      de até 3 (três) anos.
    </Text>
    <Text>A avaliação do PGR ocorrerá considerando:</Text>
    <Text>
      <ul>
        <li>
          Os agravos à saúde aos trabalhadores envolvidos no PGR. O PCMSO em seu relatório analítico apresenta esses
          tipos de informação.
        </li>
        <li>O cumprimento do Plano de ação, suas metas e prioridades (se existente);</li>
        <li>Implementação das Medidas de Controle.</li>
      </ul>
    </Text>
    <Separator weight={8} />
  </View>
)

export default StructureSection
